import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
export const TeamColorBox = ({ color, onClick, sx = {}, }) => {
    return (_jsx(Box, { sx: {
            minWidth: 32,
            minHeight: 32,
            bgcolor: color,
            border: "1px solid #ccc",
            borderRadius: "50%",
            marginRight: 1,
            ...sx,
        }, onClick: onClick }));
};
